import { ColoursObj, Icon, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { MemberProfilePic } from '../../../home/team/MemberProfilePic'
import { chatFallBackName } from '../../../state/rocketchatState/rocketchatSignals'
import { safeSignalSet } from '../../../utils'
import { useGetChatName } from '../hooks/useGetChatName'
import { useRocketChatContext } from '../rocketChatProvider'
import { useChatBodyContext } from './chatProvider'

const groupTypeIcons = [
    { type: 'Group', icon: 'Users' },
    { type: 'User', icon: 'User' },
    { type: 'Accommodation', icon: 'Stays' },
    { type: 'Flight', icon: 'Flight' },
    { type: 'Activity', icon: 'Activity' },
    { type: 'Transport', icon: 'Bus' },
    { type: 'ParkingBooking', icon: 'Parking' },
    { type: 'HireCar', icon: 'Hire_Car' },
    { type: 'VehicleAllocation', icon: 'Car_Allocation' },
    { type: 'Activity', icon: 'Activity' },
]

export const ChatTitle = () => {
    const { api, directChannelUser, roomID } = useChatBodyContext()
    const { chatView } = useRocketChatContext()
    const chatName = useGetChatName(roomID ?? '')

    const renderGroupIcon = (groupType: string) => {
        const matchedIcon = groupTypeIcons.find(
            (item) => item.type === groupType
        )
        return (
            <Icon
                width="32px"
                height="32px"
                iconColour={ColoursObj.shades.shade5}
                bubble
                bubbleColour={ColoursObj.shades.shade2}
                name={(matchedIcon?.icon as any) ?? 'Activity'}
            />
        )
    }

    return (
        <Stack
            width="calc(100vw - 160px)"
            direction="row"
            alignItems="center"
            spacing="8px"
            flexDirection="row"
            display="flex"
            onClick={() => {
                safeSignalSet(chatView, 'chatInfo')
            }}
        >
            {api?.value?.roomType === 'd' && (
                <MemberProfilePic rcUser={directChannelUser} />
            )}
            {api?.value?.roomType === 'c' &&
                renderGroupIcon(api.value.groupType)}

            <Typography
                variant="bodyBold"
                overflow="hidden"
                textOverflow="ellipsis"
                color={ColoursObj.core.primary}
            >
                {chatName ?? chatFallBackName.value ?? ''}
            </Typography>
        </Stack>
    )
}
